import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='kids-program']")
	if (!Home) return
	console.log('Page kids program');

	
	const toogleAcondeonDesktop = () =>{
			const btnAcordion = document.querySelectorAll('[data-program-content]')
			const conteudoContent = document.querySelectorAll('[data-program-kids]')
		
			btnAcordion.forEach(acordeon =>{
					acordeon.addEventListener('click', (e)=>{
						btnAcordion.forEach(i=>{i.querySelector('p').classList.add('hidden')})
							const p = acordeon.querySelector('p')
							p.classList.toggle('hidden')
							conteudoContent.forEach(conteudo=>{
								if (acordeon.dataset.programContent === conteudo.dataset.programKids)
										conteudo.classList.remove('disable')
								else
										conteudo.classList.add('disable')
										console.log(acordeon.dataset.programContent,conteudo.dataset.programKids);
							})
							
					})
			})
	}

	toogleAcondeonDesktop()


	const toogleAcondeonMobile = () =>{
			const acordeonMobile = document.querySelectorAll('.card-kids-mobile')

			acordeonMobile.forEach(i =>{
				i.addEventListener('click', ()=>{
						const svg = i.querySelector('.seta-svg')
						const textContent = i.querySelector('.text-content-expand')
						svg.classList.toggle('rotate-180')
						textContent.classList.toggle('disable')				
				})
			})
	}

	toogleAcondeonMobile()


}